import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, Field, reduxForm, reset } from 'redux-form';
import {
  renderAutoCompleteMultipleSelection, renderCheckBox, renderDateField, renderTextField, renderAutoCompleteSingleSelect,
} from '../../../../components/reduxFields';
import RaisedButton from 'material-ui/RaisedButton';
//import PaginatorCustom from '../../../../components/paginationCustom';
import moment from 'moment';
import {
  getAppliedPaymentsDetails, getClaimMasterData,  getPatient, DeleteBatchAppliedPayments, getPaymentDetails   
} from './actions/ManageClaimActions';
import { resetFiltersAndSorting, showFormatedDate, showNormalizedRate } from '../../../../actions/utilAction';
import Alert from 'react-s-alert';
//import SubString from 'add-ellipsis';
import SortingCustom from '../../../../components/SortingCustom';
import AppliedBatchPaymentDetailModal from './AppliedBatchPaymentDetailModal';
import AppliedPaymentDetailModal from './AppliedPaymentDetailModal';

const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class AppliedPaymentDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {   
      FromDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      ToDate: new Date(),
      PaymentDate: null,      
      PatientId: null,
      MethodOfPosting: null,
      PayerControlNumber: null,
      CheckNumber: null,
      PayerName: null,
      PatientIds: null,      
      selectedPaymentIds: [],           
      PaymentType: null,      
      MethodOfPostingArray: [{ id: 1, value: '835 Response' }, { id: 2, value: 'Apply Payments' }, { id: 3, value: 'Payment Ledger' }],
      openBatchServicePaymentModal: false,
      open: false,      
      claimId: null,
      paymentId: null,
      serviceLineId: null,
      chequeNo: null,
      totalCheckAmount: null,
      depositDate: null,
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'desc',
    };

    this.handleSearchAppliedPayments = this.handleSearchAppliedPayments.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);    
    this.checkAllPayments = this.checkAllPayments.bind(this);
    this.CheckClaim = this.CheckClaim.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);    
    this.handleBatchUpdatePayment = this.handleBatchUpdatePayment.bind(this); 
  }

  loadData(pageNumber) {
    // let fromDate = this.state.FromDate,
    //   toDate = this.state.ToDate;
    // console.log('load Data---', this.state.PayerName);
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'id',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {        
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
        paymentDate: this.state.PaymentDate ? moment(this.state.PaymentDate).format('YYYY-MM-DD') : null,        
        patientIds: this.state.PatientIds ? this.state.PatientIds : '',
        payerName: this.state.PayerName ? this.state.PayerName : '',
        methodOfPosting: this.state.MethodOfPosting ? this.state.MethodOfPosting : '',
        paymentType: this.state.PaymentType ? this.state.PaymentType : '',
        payerControlNumber: this.state.PayerControlNumber ? this.state.PayerControlNumber : '',   
        checkNumber: this.state.CheckNumber ? this.state.CheckNumber : '',                
      },
      pageNumber: pageNumber ? pageNumber : 1,
      // pageSize: GlobalVariables.PageSize,
    };
    // console.log('searchObj........',searchObj)
    this.props.getAppliedPaymentsDetails(searchObj);
  }

  componentWillMount() {
    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);
    this.loadData();

    let masterData = { 'masterdata': 'masterInsuranceCompany,MASTERPAYMENTTYPE,MASTERPAYMENTDESCRIPTION,MASTERADJUSTMENTGROUPCODE' };
    this.props.getClaimMasterData(masterData);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.appliedPaymentDeleted && nextProps.appliedPaymentDeleted !== this.props.appliedPaymentDeleted) {
      this.setState({ selectedPaymentIds : [] },()=>{
        this.loadData();
      });      
    }  

    if (nextProps.addedPaymentDetails && nextProps.addedPaymentDetails !== this.props.addedPaymentDetails) {
      this.loadData();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;

      this.loadData();
    }
  }
  handleNewRequestMultiSelect(input, selectedValues) {
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    }   
  }

  handleChangePatientInsurance = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ PayerName: selected.label })
  }

  handleChangePaymentType = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ PaymentType: selected.label })
  }

  handleChangeMethodOfPosting = (input, selected) => {
    input.onChange(selected.value);
    this.setState({ MethodOfPosting: selected.label })
  }

  loadModalData(paymentId) {
    // let masterData = {
    //   'masterdata': 'MASTERPAYMENTTYPE,MASTERPAYMENTDESCRIPTION',
    // };
    // this.props.getMasterData(masterData);
    if (paymentId) {
      this.props.getPaymentDetails(paymentId);
    }
  }
  
  handleEditClick(e, obj) {   
    //console.log('obj.......',obj)
    this.loadModalData(obj.paymentId);
    this.setState({ open: true, claimId: obj.claimId, patientId: obj.patientId, paymentId: obj.paymentId, serviceLineId: obj.serviceLineId });
  }

  handleSearchAppliedPayments(event) {
    this.setState({
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(new Date().setDate(new Date().getDate() - 1)),
      ToDate: event.ToDate ? showFormatedDate(event.ToDate) : new Date(),
      PaymentDate: event.PaymentDate ? showFormatedDate(event.PaymentDate) : null,     
      PatientIds: this.state.PatientIds ? this.state.PatientIds : '',
      PayerName: this.state.PayerName ? this.state.PayerName : '',   
      MethodOfPosting: this.state.MethodOfPosting ? this.state.MethodOfPosting : '',
      PayerControlNumber: event.PayerControlNumber ? event.PayerControlNumber : null,   
      CheckNumber: event.CheckNumber ? event.CheckNumber : null,         
      PaymentType: this.state.PaymentType ? this.state.PaymentType : '',   
    }, () => {
      this.loadData();
    });
    // console.log('event............',event);
  }


  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }


  ResetAllClaims() {
    this.props.dispatch(change('AppliedPaymentDetailForm', 'Chkclaim', false));
    let claimData = this.props.appliedPaymentDetails.data;    
    claimData.forEach((obj, claimIndex) => {
      let claimIdCheck = `Claims[${claimIndex}].Chk`;
      this.props.dispatch(change('AppliedPaymentDetailForm', claimIdCheck, false));
    });
  }

  checkAllPayments(e, paymentId) {
    let isAllClaimChecked = e.target.checked,
      claimData = this.props.appliedPaymentDetails.data;      
    let selectedPaymentIds = [], patientId = null, chequeNo = '', totalCheckAmount = null, depositDate = null;
    claimData.forEach((obj, claimIndex) => {
      let claimIdCheck = `Claims[${claimIndex}].Chk`;
      if (obj && isAllClaimChecked) {        
        patientId = obj.patientId;    
          selectedPaymentIds.push(obj.paymentId);        

          if(chequeNo === '') {
            chequeNo = obj.checkNumber === null ? '' : obj.checkNumber;
            totalCheckAmount = obj.totalCheckAmount === null ? 0.00 : obj.totalCheckAmount;
            depositDate= obj.depositDate === null ? '' : obj.depositDate;
          }
          else if(chequeNo != obj.checkNumber) {
            chequeNo = '';
            totalCheckAmount = 0;
            depositDate = null;
          }
        this.props.dispatch(change('AppliedPaymentDetailForm', claimIdCheck, true));
      } else {
        this.props.dispatch(change('AppliedPaymentDetailForm', claimIdCheck, false));
      }
    });
    this.setState({ selectedPaymentIds, patientId, chequeNo: chequeNo, totalCheckAmount: totalCheckAmount, depositDate: depositDate });
  }

  CheckClaim(e, index, data) {    
    let selectedPaymentIds = this.state.selectedPaymentIds, chequeNo = '', totalCheckAmount = null, depositDate = null;
    let patientId = this.state.patientId;
    let isClaimChecked = e.target.checked;
    if (isClaimChecked) {     
      selectedPaymentIds.push(data.paymentId);    
      patientId = data.patientId;    
      if(chequeNo === '') {
        chequeNo = data.checkNumber === null ? '' : data.checkNumber;
        totalCheckAmount = data.totalCheckAmount === null ? 0.00 : data.totalCheckAmount;
        depositDate= data.depositDate === null ? '' : data.depositDate;
      }
      else if(chequeNo != data.checkNumber) {
        chequeNo = '';
        totalCheckAmount = 0;
        depositDate = null;
      }
    } else {     
        index = selectedPaymentIds.findIndex((value) => value === data.paymentId);
        if (index >= 0) {
          selectedPaymentIds.splice(index, 1);         
        }      
    }

    this.setState({ selectedPaymentIds, patientId, chequeNo: chequeNo, totalCheckAmount: totalCheckAmount, depositDate: depositDate });
  }

  handleReset = () => {
    // console.log('reset FirstName---', this.state.FirstName);
    // console.log('reset LastName---', this.state.LastName);
    // console.log('reset PayerName---', this.state.PayerName);
    this.props.dispatch(reset('AppliedPaymentDetailForm'));
    // this.props.dispatch(change('AppliedPaymentDetailForm', 'InsuranceCompany', null));
    resetFiltersAndSorting(this.filter, 'paymentId', true);
    this.setState({                 
      FromDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      ToDate: new Date(),
      PaymentDate: null,      
      PatientId: null,
      MethodOfPosting: null,
      PayerControlNumber: null,
      PayerName: null,
      PatientIds: null,      
      selectedPaymentIds: [],      
      PaymentType: null,  
      MethodOfPosting: null,     
      CheckNumber: null,
      openBatchServicePaymentModal: false,
    }, () => {
      this.loadData();
    });
  };
 
  componentWillUnmount() {
    Alert.closeAll();
  }

  handleBatchUpdatePayment = (event) => {
    //console.log('hi')
    this.setState({ openBatchServicePaymentModal: true });
  }  

  handleCloseBatchServicePayments = () => {
    this.setState({ openBatchServicePaymentModal: false, selectedPaymentIds: [], open: false, paymentId: null, serviceLineId: null, claimId: null, patientId: null });
    this.ResetAllClaims();
  }

  handleAlertDeleteBatchAppliedPaymentsClick = (event) => {
    this.props.DeleteBatchAppliedPayments(this.state.selectedPaymentIds.toString());
    Alert.closeAll();
  }

  handleDeleteBatchAppliedPaymentsClick = (event) => {
    Alert.warning('Are you sure you want to delete selected payments?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertDeleteBatchAppliedPaymentsClick,
        //id: obj.id,
      },
    });
  }


  render() {
    // console.log(this.props.searchAutocompleteMUI);
    const { handleSubmit } = this.props;
    const tableClass = classNames({
        'table': true,
        'tablePaymentledger': true,
        'table-striped': this.props.bordered,
        'table-bordered': this.props.bordered,
        'table-hover': true,
        'table-condensed': this.props.condensed,
        'maintable': true,
        'customtable': true,
    });
    const tableClass1 = classNames({
        'table': true,
        'middletable': true,
        'customtable': true,
    });

    return (
      <div>
        {this.state.open ?
          <AppliedPaymentDetailModal
            open={this.state.open}
            patientId={this.state.patientId}
            paymentId={this.state.paymentId}
            serviceLineId={this.state.serviceLineId}
            closeDialog={this.handleCloseBatchServicePayments}
            claimId={this.state.claimId}/>
          : null}
        <h2 className="page_title">Applied Payments Details</h2>        
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchAppliedPayments)}>
              <div className="row mtm-20">
                <div className="col-sm-4">
                  <Field name="PaymentDate"
                    placeholder="Payment Date"
                    locale="en-US"
                    selected={this.state.PaymentDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>                
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.patientlist}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 mt-35">
                  <Field
                    name="InsuranceCompany"
                    label="Insurance Company"
                    handleNewRequest={this.handleChangePatientInsurance}
                    options={this.props.masterInsurances}
                    component={renderAutoCompleteSingleSelect} />               
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>               
                <div className="col-sm-4 mt-35">
                  <Field
                    name="MethodOfPosting"
                    label="Method Of Posting"
                    handleNewRequest={this.handleChangeMethodOfPosting}
                    options={this.state.MethodOfPostingArray}
                    component={renderAutoCompleteSingleSelect} />               
                </div>
              </div>
              <div className="row">     
                <div className="col-sm-4 mt-35">
                  <Field
                    name="PaymentType"
                    label="Payment Type"
                    handleNewRequest={this.handleChangePaymentType}
                    options={this.props.masterPaymentType}
                    component={renderAutoCompleteSingleSelect} />               
                </div>
                <div className="col-sm-4">
                  <Field
                    autoFocus={true}
                    name="PayerControlNumber"
                    floatingLabelText="Payer Control Number"                   
                    component={renderTextField} />
                </div>     
                <div className="col-sm-4">
                  <Field                    
                    name="CheckNumber"
                    floatingLabelText="Check Number"                   
                    component={renderTextField} />
                </div>               
              </div>
              <div className="row">     
                <div className="col-8 col-sm-8 col-md-8 reset-btn claims_btn">     
                  {this.props.generateBatchEDIClaimPermission ?
                      <RaisedButton className={this.state.selectedPaymentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedPaymentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleDeleteBatchAppliedPaymentsClick(e)} >Batch Delete Payments</RaisedButton>
                      : null}
                  {this.props.generateBatchEDIClaimPermission ?
                    <RaisedButton className={this.state.selectedPaymentIds.length > 0 ? "grey_btn ml_15" : "grey_btn ml_15 reset-disable"} disabled={this.state.selectedPaymentIds.length > 0 ? false : true} onTouchTap={(e) => this.handleBatchUpdatePayment(e)} >Batch Update Payments</RaisedButton>
                    : null}
                </div>             
                <div className="col-4 col-sm-4 col-md-4 btn_rt reset-btn claims_filter">
                  <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
                <div className="row"><div className="col-12"></div></div>               
            </form>
            {this.state.openBatchServicePaymentModal && <AppliedBatchPaymentDetailModal open={this.state.openBatchServicePaymentModal} patientId= {this.state.patientId} paymentIds={this.state.selectedPaymentIds} chequeNo={this.state.chequeNo} totalCheckAmount={this.state.totalCheckAmount} depositDate={this.state.depositDate} closeDialog={this.handleCloseBatchServicePayments} />}

            <div className="row">
              <div className="col-sm-12">
                  <div className="table-responsive mt-15">
                  {this.props.appliedPaymentDetails.data ? this.props.appliedPaymentDetails.data.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="5%">
                            <div className="table_custom-check">
                              <Field
                                name='Chkclaim'
                                component={renderCheckBox}
                                onChange={(e) => this.checkAllPayments(e, this.props.appliedPaymentDetails.data.paymentId)}
                                style={stylescss.checkbox}
                              />
                              <span>&nbsp;</span>
                            </div>
                          </th>
                          <th width="8%"><SortingCustom setSortColumn={this.setSortColumn} columnName='dos' displayName='Date Of Service' /></th>
                          <th width="10%">Client Name</th>                          
                          <th width="9%">Date Applied</th>  
                          <th width="9%">Payment Source</th>
                          <th width="9%">Payment Type</th>
                          <th width="9%">Description Type</th>
                          <th width="9%">Method Of Posting</th>
                          <th width="10%">Payer Control Number</th>
                          <th width="9%">Check Number</th>
                          <th width="6%">Amount($)</th>              
                          <th width="5%">Action</th>            
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.appliedPaymentDetails.data.map((data, index) => {
                          return (
                            <tr key={index}>
                               <td colSpan="12">
                                  <table className={tableClass1}>
                                      <tbody>
                                          <tr>
                                            <td width="5%">
                                              <div className="table_custom-check">
                                                <Field
                                                  name={`Claims[${index}].Chk`}
                                                  component={renderCheckBox}
                                                  onChange={(e) => this.CheckClaim(e, index, data)}
                                                  style={stylescss.checkbox}
                                                />
                                              </div>
                                            </td>                         
                                            <td width="8%">{showFormatedDate(data.dos)}</td>
                                            <td width="10%">{data.patientName}</td>         
                                            <td width="9%">{showFormatedDate(data.paymentDate)}</td>                                    
                                            {/* <td width="15%">{data.payer != null && data.payer.length > 15 ? SubString(data.payer, 15, data.payer.length) + '...' : data.payer != null ? data.payer : 'N/A'}</td>                                      */}
                                            <td width="9%">{data.payerName ? data.payerName : data.postedPatientName ? 'Self' : 'Guarantor'}</td>
                                            <td width="9%">{data.paymentType || '-'}</td>
                                            <td width="9%">{data.descriptionType || '-'}</td>
                                            <td width="9%">{data.methodOfPosting || '-'}</td>
                                            <td width="10%">{data.payerControlNumber || '-'}</td>
                                            <td width="9%">{data.checkNumber || '-'}</td>
                                            <td width="6%">{showNormalizedRate(data.amount || 0)}</td>
                                            <td width="5%">
                                              <button onClick={(e) => this.handleEditClick(e, data)} type="button" title="Edit Payment" className="tbactionbtn bluefont"><i className="fa fa-edit" aria-hidden="true"></i></button>
                                            </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </td>
                            </tr>                                    
                          );
                        })
                        }
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="5%"><span>&nbsp;</span></th>
                          <th width="8%">DOS</th>                                              
                          <th width="10%">Client Name</th>                          
                          <th width="9%">Date Applied</th>  
                          <th width="9%">Payment Source</th>
                          <th width="9%">Payment Type</th>
                          <th width="9%">Description Type</th>
                          <th width="9%">Method Of Posting</th>
                          <th width="10%">Payer Control Number</th>
                          <th width="9%">Check Number</th>
                          <th width="6%">Amount($)</th>              
                          <th width="5%">Action</th>  
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="12">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}
                  {/* {this.props.appliedPaymentDetails.data && this.props.appliedPaymentDetails.meta && this.props.appliedPaymentDetails.meta['totalPages'] && this.props.appliedPaymentDetails.meta['totalPages'] > 1 ?
                    <PaginatorCustom data={this.props.appliedPaymentDetails.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
                    : null} */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
AppliedPaymentDetail = reduxForm({
  form: 'AppliedPaymentDetailForm',
})(AppliedPaymentDetail);
// const selectorAppliedPaymentDetailForm = formValueSelector('AppliedPaymentDetailForm');

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [],
    patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'BILLING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'BILLING_CLAIMS' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permissio

  let generateBatchEDIClaimPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'BILLING_CLAIMS_READYTOBILL_GENERATEBATCH_EDICLAIM')[0].permission : false;
  
  // End For Role Permission
  // console.log('state.billing.appliedPaymentDetails......', state.billing.appliedPaymentDetails);
 
  let masterInsurances = [], masterPaymentType = [];
  if (state.billing.claimMasterData) {
    masterInsurances = state.billing.claimMasterData.insuranceCompanies || [];
    masterPaymentType = state.billing.claimMasterData.masterPaymentType || [];
  }

  return {
    master_data: state.billing.master_data,
    masterInsurances: masterInsurances,    
    masterPaymentType: masterPaymentType,
    currentLocationId: state.login.currentLocationId,
    appliedPaymentDetails: state.billing.appliedPaymentDetails,    
    appliedPaymentDeleted: state.billing.appliedPaymentDeleted,        
    patientlist: patients,
    loginUserInfo: state.login.loginUserInfo,
    generateBatchEDIClaimPermission: generateBatchEDIClaimPermission,
    addedPaymentDetails: state.billing.addedPaymentDetails,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, {  getAppliedPaymentsDetails, getClaimMasterData,  getPatient, DeleteBatchAppliedPayments, getPaymentDetails })(AppliedPaymentDetail);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/AppliedPaymentDetail.js